import {useEffect} from 'react';

import {useUserDynamicConfigWithLoading} from '../useDynamicConfig';
import {
  parsePerformanceObserverConfiguration,
  performanceObserverConfiguration,
} from './performanceObserverConfiguration';

export function usePerformanceObserverConfiguration(): void {
  const {config} = useUserDynamicConfigWithLoading(
    'performance_observer_configuration'
  );
  useEffect(() => {
    performanceObserverConfiguration.setState(
      parsePerformanceObserverConfiguration(config),
      true
    );
  }, [config]);
}
